import * as React from 'react';

function SizeIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 16 16' fill='none' {...props}>
			<path
				d='M7.333 12.667h-4m0 0v-4m0 4l9.334-9.334m-4 0h4m0 0v4'
				stroke='#545454'
				strokeWidth={1.33333}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default SizeIcon;
